module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }), _vm._v(" "), _c('strong', [_vm._v("Copyright © " + _vm._s(new Date().getFullYear()) + " " + _vm._s(_vm.creatorName) + " - "), _vm._m(0)]), _vm._v(" - Todos os direitos reservados.\n")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-interna.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ff565e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Footer.vue
// module id = 682
// module chunks = 1